import { ESortChainsType, Timeframe } from '@ankr.com/chains-list';
import { useState } from 'react';

import { useAccount } from 'modules/account/hooks/useAccount';
import { usePrivateChainsInfo } from 'hooks/usePrivateChainsInfo';
import { useSearch } from 'modules/common/components/Search/hooks/useSearch';
import { useTimeframe } from 'domains/chains/screens/ChainPage/components/ChainItemSections/hooks/useTimeframe';

export const usePrivateChainsList = () => {
  const { isAccountInitializing } = useAccount();

  const { timeframe, timeframeTabs } = useTimeframe({
    initialTimeframe: Timeframe.Day,
    shouldResetOnGroupChange: true,
  });

  const { chains, isLoading: privateChainsLoading } = usePrivateChainsInfo();

  const [sortType, setSortType] = useState(ESortChainsType.Trending);

  const [searchContent, setSearchContent] = useSearch();

  return {
    chains,
    loading: isAccountInitializing || privateChainsLoading,
    searchContent,
    setSearchContent,
    setSortType,
    sortType,
    timeframe,
    timeframeTabs,
  };
};
